import GlobalConfiguration from './GlobalConfiguration';


export default GlobalConfiguration;
